import { render, staticRenderFns } from "./FiltersDeleteForm.vue?vue&type=template&id=6ad6c12d&scoped=true&lang=pug&"
import script from "./FiltersDeleteForm.vue?vue&type=script&setup=true&lang=js&"
export * from "./FiltersDeleteForm.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./FiltersDeleteForm.vue?vue&type=style&index=0&id=6ad6c12d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad6c12d",
  null
  
)

export default component.exports